import { HStack, Text } from '@chakra-ui/react';
import React from 'react';
import { SelectNetwork } from '@app/screens/router-intent/components/SelectNetwork/SelectNetwork';
import { SelectToken } from '@app/screens/router-intent/components/SelectToken';
import { DebouncedInput } from '@app/components/DebouncedInput';
import { formatUSD } from '@app/helpers/formatUSD';
import { SourceAmount } from '@app/screens/router-intent/components/SourceAmount';
import { AddLiquiditySectionTitle } from '@app/screens/liquidity/AddLiquidityV3/components/AddLiquiditySectionTitle';
import { useRouterIntentState } from '@app/state/routerIntentStore';

export const SourceDetailsSelector = () => {
  const { sourceNetwork, sourceToken, sourceAmount } = useRouterIntentState();

  return (
    <>
      <AddLiquiditySectionTitle
        label="Choose an asset"
        isCompleted={Boolean(sourceNetwork && sourceToken && sourceAmount)}
      />
      <HStack mt={4} gap={4} width="100%">
        <SelectNetwork />
        <SelectToken />
      </HStack>
      <SourceAmount />
    </>
  );
};
